import { useState, useEffect, useCallback, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;
const POLL_INTERVAL = 60000; // Check every 60 seconds

export const useVersionCheck = () => {
  const [versionInfo, setVersionInfo] = useState(null);
  const [updateAvailable, setUpdateAvailable] = useState(false);
  const baselineVersion = useRef(null);

  const checkVersion = useCallback(async () => {
    try {
      const res = await fetch(`${API}/api/version?_=${Date.now()}`, { cache: 'no-store' });
      if (!res.ok) return;
      const data = await res.json();
      setVersionInfo(data);

      if (!baselineVersion.current) {
        // First check — store as baseline
        baselineVersion.current = data.version;
        sessionStorage.setItem('app_version', data.version);
      } else if (data.version !== baselineVersion.current) {
        // Version changed during this session — show banner only, no auto-refresh
        setUpdateAvailable(true);
      }
    } catch {
      // Silently fail
    }
  }, []);

  useEffect(() => {
    checkVersion();
    const interval = setInterval(checkVersion, POLL_INTERVAL);
    return () => clearInterval(interval);
  }, [checkVersion]);

  const refreshApp = () => {
    sessionStorage.setItem('app_version', versionInfo?.version || '');
    window.location.href = window.location.pathname + '?_v=' + Date.now();
  };

  const dismissUpdate = () => {
    setUpdateAvailable(false);
    baselineVersion.current = versionInfo?.version;
    sessionStorage.setItem('app_version', versionInfo?.version || '');
  };

  return { versionInfo, updateAvailable, refreshApp, dismissUpdate };
};
